import { useSWRConfig } from 'swr';
import { deleteFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { displayError } from '@/utils/error/errorHandler';

/**
 * Hook that returns function that deletes the employee's attachment by id.
 */
const useDeleteEmployeeAttachment = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const deleteEmployeeAttachment = async (attachmentId: number) => {
    try {
      await deleteFetcher(
        `/employees/${employeeId}/attachments/${attachmentId}`
      );
      // revalidate (= automatically refetch attachments)
      await mutate(`/employees/${employeeId}/attachments`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    deleteEmployeeAttachment,
  };
};

export default useDeleteEmployeeAttachment;
